import style from './job-menu.scss';
import inView from 'in-view';
import timing from './../../../design-system/motion/timing';
import staticSizes from './../../../design-system/layout/static-sizes';

const script = () => {
  const cssClass: string = 'JobMenu';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    // Get amount informations per jobs
    let amountInformations: IAmountDatas = {};
    if (typeof drupalSettings !== 'undefined' && drupalSettings.adt_job?.jobs_per_domain) {
      amountInformations =  drupalSettings.adt_job.jobs_per_domain;
    }
    if (typeof amountInformationsByJobs === 'object') {
      amountInformations =  amountInformationsByJobs;
    }

    for (const [_i, job] of Object.entries(amountInformations)) {

      const jobAmount = job.amount;
      const jobItem = elt.querySelector(`.${cssClass}-link[data-termid="${_i}"]`);

      // Add the amount to the corresponding item
      if (jobItem !== null && jobAmount) {
        const amountHTML: HTMLElement = document.createElement('span');
        amountHTML.classList.add(`${cssClass}-amount`);
        amountHTML.innerHTML = ` (${jobAmount})`;
        jobItem.appendChild(amountHTML);
      }
    }

    // Activate in view on each item
    const items: any = elt.querySelectorAll(`.${cssClass}-item`);
    inView.offset(staticSizes.params['in-view'].offset.mobile);
    inView(`.${cssClass}`)
        .on('enter', ()=>{
          elt.classList.add('isInViewport');

           for (const item of items) {
             item.style.animationDelay = `${timing.params.slow / items.length * Array.prototype.indexOf.call(items, item)}ms`;
           }
        });
  }
};

export {
  style,
  script,
};
